export const RoutePaths = {
    root: '/',
    dashboard: '/dashboard',

    // Login paths
    login: '/login',
    forgotPassword: '/forgot-password',
    changePassword: '/change-password',
    resetPassword: '/reset-password',

    // Job paths
    jobs: '/jobs',
    saveJob: '/save-job',

    // Job application paths
    jobApplications: '/job-applications',

    // Save for later paths
    savedForLater: '/saved-for-later',

    //Position paths
    positions: '/positions',

    // Reports paths
    reports: '/reports',

    // Tools paths
    chat: '/chat',
    companyDetails: '/company-details',
    settings: '/settings',
    emailTemplates: '/settings/email-templates',
    userSettings: '/user-settings',
    viewAnswerHistory: '/view-answer-history',

    // Public pages
    termsAndServices: '/terms-and-services',
    privacyPolicy: '/privacy-policy',
    scheduleInterview: '/schedule-interview',
};
